//////////////////////////////
// Cookie
function setCookie(name, value, options = {}) {
  const defaultOptions = {
    expires: 30,
    path: '/',
    sameSite: 'Lax',
    secure: location.protocol === 'https:',
  };

  const finalOptions = { ...defaultOptions, ...options };
  if (typeof Cookies?.set !== 'function') {
    console.error('js-cookie not loaded.');
    return;
  }
  Cookies.set(name, value, finalOptions);
}

function getCookie(name) {
  if (typeof Cookies?.get !== 'function') {
    console.error('js-cookie not loaded.');
    return null;
  }

  return Cookies.get(name) || null;
}
//////////////////////////////
// Close Promo Text
$(document).ready(() => {
  const promoBanner = getCookie('promo-banner');
  if (promoBanner != 'dismiss') {
    $(`#header-promo-banner`).addClass('wp-flex');
    $(`#header-promo-banner`).removeClass('wp-hidden');
  }
});
function closePromo() {
  setCookie('promo-banner', 'dismiss', {
    expires: 30,
    path: '',
    domain: '',
    sameSite: 'None',
    secure: true,
  });
  $(`#header-promo-banner`).addClass('wp-hidden');
}
//////////////////////////////
// Main Menu Open
let toggleBtn = document.getElementById('drawerToggle');
let drawer = document.getElementById('drawerMenu');
let closeBtn = document.getElementById('drawerClose');

toggleBtn.addEventListener('click', () => {
  drawer.classList.remove('wp-hidden');
  drawer.classList.add('wp-fixed');
  document.body.classList.add('wp-overflow-y-hidden');

  setTimeout(() => {
    drawer.classList.remove('wp--translate-x-full');
  }, 10);
});

closeBtn.addEventListener('click', () => {
  drawer.classList.add('wp--translate-x-full');
  document.body.classList.remove('wp-overflow-y-hidden');
  setTimeout(() => {
    drawer.classList.add('wp-hidden');
    drawer.classList.remove('wp-fixed');
  }, 300);
});

document.addEventListener('click', (e) => {
  if (!drawer.contains(e.target) && !toggleBtn.contains(e.target)) {
    drawer.classList.add('wp--translate-x-full');
    document.body.classList.remove('wp-overflow-y-hidden');

    setTimeout(() => {
      drawer.classList.add('hidden');
    }, 300);
  }
});

//////////////////////////////
// Sub Menu Open

function openSubMenu(id, menuSize, isAMenu) {
  if (menuSize > 0 && isAMenu) {
    let drawerSubOpen = document.getElementById('drawerSubMenu_' + id);
    drawerSubOpen.classList.remove('wp-hidden');
    drawerSubOpen.classList.add('wp-fixed');
    setTimeout(() => {
      drawerSubOpen.classList.remove('wp--translate-x-full');
    }, 10);
  }
}
function closeSubMenu(id) {
  let drawerSub = document.getElementById('drawerSubMenu_' + id);
  drawerSub.classList.add('wp--translate-x-full');
  setTimeout(() => {
    drawerSub.classList.remove('wp-fixed');
    drawerSub.classList.add('wp-hidden');
  }, 100);
}

//////////////////////////////
// Change Cart Item
// Type: plus/ minus
let changeCartTimeout = null;
let changeInputTimeOut = null;

function changeCartItem(type, inputId, isLoading) {
  let qty = parseInt($(`#${inputId}`).val());

  if (type == 'plus') {
    qty = qty + 1;
  }

  if (type == 'minus') {
    qty = qty - 1;
    if (qty <= 0) {
      qty = 0;
    }
  }
  $(`#${inputId}`).val(qty);
  if (changeCartTimeout) clearTimeout(changeCartTimeout);
  changeCartTimeout = setTimeout(async () => {

    onChangeCart($(`#${inputId}`), isLoading);
  }, 700);
}

async function onChangeCart(element, isLoading) {
  const inputElement = $(element)
  const qty = parseInt(inputElement.val());

  const itemKey = inputElement.attr('data-cart-item-key');
  if (!isNaN(qty)) {
    if (qty <= 0 && isLoading) {
      openModalRemove(element, false, inputElement);
    }
    else {
      if (isLoading && qty > 0) {
        showUIBlock();
      }
      callAPIUpdateCart(qty, itemKey, isLoading);
    }
  }

}

function onChangeCartInput(element, isLoading) {
  if (changeInputTimeOut) clearTimeout(changeInputTimeOut);
  changeInputTimeOut = setTimeout(async () => {
    onChangeCart(element, isLoading);
  }, 1000);
}

function callAPIUpdateCart(qty, itemId, isLoading) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: itemId,
      quantity: qty,
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: async function (cart) {
      if (cart?.item_count > 0) {
        await fetchTemplateCartPageCart(cart, 'cart-drawer-template', 'cart_form', true);
      }
      else {
        await fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);

      }
      await fetchTemplateCartPageCart(cart, 'cart-template', 'cart_line_form', false);
      closeModalOverLay();
      if (isLoading) {
        hideUIBlock();
      }
    },
    error: function (err) {
      hideUIBlock();
      console.error(err);
    },
  });
}

function fetchTemplateCart(cart, sectionId, targetId, isReplaceAll) {
  $.ajax({
    url: `/?section_id=${sectionId}`,
    success: function (data) {
      let $target = $(`#${targetId}`);

      if (isReplaceAll) {
        const newSection = $(data).html();
        $target.replaceWith(newSection);
      } else {
        const newSection = $(data).find(`#${targetId}`).html();
        $target.html(newSection);
      }

      $('#cart_number').html(`(${cart.item_count}) Cart`);
      $('#cart_number_mobi').html(`${cart.item_count}`);

      if (cart.item_count === 0) {
        $target.remove();
        $('.wp-countdown').remove();
        $('#cart_number').removeAttr('class');
      }
    },
    error: function (err) {
      console.error(err);
    },
  });
}
